import { render, staticRenderFns } from "./payRecord.vue?vue&type=template&id=c83521e2&scoped=true"
import script from "./payRecord.vue?vue&type=script&lang=js"
export * from "./payRecord.vue?vue&type=script&lang=js"
import style0 from "./payRecord.vue?vue&type=style&index=0&id=c83521e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83521e2",
  null
  
)

export default component.exports